import Icon from '../components/Icon.vue'

Icon.register({
  'user-plus': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M624 208c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16h-64v64c0 8.8-7.2 16-16 16h-32c-8.8 0-16-7.2-16-16v-64h-64c-8.8 0-16-7.2-16-16v-32c0-8.8 7.2-16 16-16h64v-64c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v64h64zM224 256c-70.7 0-128-57.3-128-128s57.3-128 128-128 128 57.3 128 128-57.3 128-128 128zM313.6 288c74.2 0 134.4 60.2 134.4 134.4v41.6c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-41.6c0-74.2 60.2-134.4 134.4-134.4h16.7c22.3 10.2 46.9 16 72.9 16s50.7-5.8 72.9-16h16.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-plus.js
// module id = 2072
// module chunks = 0